export function paymentReferenceDisplayValue(reference: string | null | undefined): string {
  const normalized = String(reference || "").trim();
  if (!normalized) return "";

  const [runReference] = normalized.split(" | ", 1);
  if (/^(LS|Lastschrift)\s+\d{2}\.\d{2}\.\d{4}$/i.test(runReference)) {
    return runReference;
  }

  return normalized;
}
